<template>
	<div class="top-menu">
		<Link
			v-for="(link, index) in links"
			:key="index"
			:title="link.title"
			:url="link.url"
			:target="link.target"
			:className="index + ' ' + link.class"
			:svg="link.image"
		/>
		<Search />
		<li>
			<a
				:href="langUrl"
				rel="noopener noreferrer"
				class="no-submenu link-menu lang"
				v-html="$t('Common.lang.title')"
			>FR</a>
		</li>
	</div>
</template>

<script>
import Link from '../partials/Link.vue'
import Search from '../partials/Search.vue'
export default {
	name: 'TopNavbar',
	components: { Link, Search },
	computed: {
		links() {
			return this.$t('TopNavbar')
		},
		langUrl() {
			if (window.location.href.includes('majestic.dev')) {
				return this.$t('Common.lang.staging')
			} else if (
				window.location.href.includes('thefoodbankhelps.ca') ||
				window.location.href.includes('abanquealimentairevousaide.ca')
			) {
				return this.$t('Common.lang.live')
			}
			return this.$t('Common.lang.url')
		},
	},
}
</script>
<style scoped lang="scss">
a {
	&.lang {
		width: 36px;
		text-align: center;
		margin-top: -4px;
		border: 2px solid $grayTheme;
		text-transform: uppercase;
		padding: 4px;

		@include uncollapsed {
			&.active,
			&:hover,
			&:focus {
				border-color: $yellowTheme;
			}
		}
	}
}
</style>